"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BannerModule = _interopRequireDefault(require("./Banner.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Banner = function Banner(_ref) {
  var backgroundImage = _ref.backgroundImage,
      bannerContent = _ref.bannerContent;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _BannerModule["default"].banner,
    style: {
      backgroundImage: backgroundImage
    }
  }, bannerContent);
};

var _default = Banner;
exports["default"] = _default;